import { createReducer } from '@reduxjs/toolkit';
import {
    SET_TOTAL_PRIZES,
    SET_TOTAL_PRIZES_WON,
    SET_HUNT_REGULATION,
    SET_PRIZES_INFO,
    SET_HUNT_ALL_INFOS,
    SET_HUNTE_INFOS_UPDATED,
} from '../actions/CacaAoTesouroAction';


const initialState = {
    totalPrizes: 0,
    totalPrizesWon: 0,
    huntRegulation: null,
    prizesInfo: [],
    huntAllInfos: {},
    huntInfosUpdated: false,
};


const cacaAoTesouro = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_TOTAL_PRIZES, (state, action) => {
            state.totalPrizes = action.totalPrizes;
        })
        .addCase(SET_TOTAL_PRIZES_WON, (state, action) => {
            state.totalPrizesWon = action.totalPrizesWon;
        })
        .addCase(SET_HUNT_REGULATION, (state, action) => {
            state.huntRegulation = action.huntRegulation;
        })
        .addCase(SET_PRIZES_INFO, (state, action) => {
            state.prizesInfo = action.prizesInfo;
        })
        .addCase(SET_HUNT_ALL_INFOS, (state, action) => {
            state.huntAllInfos = action.huntAllInfos;
        })
        .addCase(SET_HUNTE_INFOS_UPDATED, (state, action) => {
            state.huntInfosUpdated = action.huntInfosUpdated;
        });
});

export default cacaAoTesouro;
